export default __webpack_public_path__ + "static/form-one-column-do-be19620e3edeb345e44cc1b7fbc33282.png";